import React from 'react';
import { TableCellProps } from '../../../types/search';
import { moneyFormat } from '../utils/tableCellUtils';

const PortalCellOutstandingBalance: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  const outstandingBalance = moneyFormat(value);

  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--outstanding-balance`}>
      <p className="portal-cell__mobile-label">Left to pay</p>
      <p>{outstandingBalance}</p>
    </div>
  );
};

export default PortalCellOutstandingBalance;
